import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, CalendarDays, User } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPostPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog/${id}`).then(r => { setPost(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin w-8 h-8 border-2 border-[var(--violet)] border-t-transparent rounded-full"></div></div>;
  if (!post) return <div className="min-h-screen flex items-center justify-center text-[var(--dark)]/50">Articulo no encontrado</div>;

  return (
    <div className="min-h-screen bg-white" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[var(--dark)]/50 hover:text-[var(--violet)] mb-8">
          <ArrowLeft className="h-4 w-4" /> Volver al blog
        </Link>

        {post.image && (
          <div className="rounded-2xl overflow-hidden mb-8 h-64 sm:h-80">
            <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
          </div>
        )}

        <Badge className="bg-[var(--sage-light)] text-[var(--sage-dark)] border-0 mb-4">{post.category || 'General'}</Badge>
        <h1 className="text-3xl sm:text-4xl font-bold text-[var(--dark)] mb-4" data-testid="post-title">{post.title}</h1>

        <div className="flex items-center gap-4 text-sm text-[var(--dark)]/40 mb-8">
          <span className="flex items-center gap-1"><User className="h-4 w-4" /> {post.author}</span>
          <span className="flex items-center gap-1"><CalendarDays className="h-4 w-4" /> {new Date(post.created_at).toLocaleDateString('es-ES')}</span>
        </div>

        <div className="prose prose-lg max-w-none text-[var(--dark)]/70 leading-relaxed whitespace-pre-line" data-testid="post-content">
          {post.content}
        </div>
      </div>
    </div>
  );
}
